import homeStyles from "../homepage.module.scss";

import { SvgInline } from "../../SvgInline/SvgInline";
import styles from "./callouts.module.scss";

function Callout({ title, iconName, children }) {
  return (
    <div className={styles.callout}>
      <SvgInline name={iconName} />
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{children}</div>
    </div>
  );
}

export function Callouts() {
  return (
    <div className={styles.wrapper}>
      <div className={`${homeStyles.container} ${styles.container}`}>
        <Callout iconName="icon-star" title="One Latitude ID">
          Register for a Latitude ID to manage all your accounts in one place.
        </Callout>
        <Callout iconName="icon-ribbon" title="New design">
          View your transactions and statements and make payments to your
          account.
        </Callout>
        <Callout iconName="icon-lightning" title="Streamlined">
          Complete the things you need to do easily and quickly with our new
          design.
        </Callout>
      </div>
    </div>
  );
}
